import { ActionDTO, ActionType } from '@gearbelt/global';

// Both ids are set positively at the emit site, so null means "unrecognised" —
// never infer one entity from the absence of the other.
function linkedEntity(action: ActionDTO): 'Issue' | 'Schedule Check' | null {
  if (action.issueId) return 'Issue';
  if (action.checkId) return 'Schedule Check';
  return null;
}

// On a work order's own timeline, name the other side of the link.
export function workOrderTaskLabel(action: ActionDTO): string | undefined {
  if (action.type !== ActionType.WorkOrderLinked && action.type !== ActionType.WorkOrderUnlinked) {
    return undefined;
  }

  const entity = linkedEntity(action);
  if (!entity) return undefined;

  return action.type === ActionType.WorkOrderLinked ? `${entity} Linked` : `${entity} Unlinked`;
}
